/**
 * API key cookie utilities
 */

const COOKIE_NAME = 'raiqon_api_key';
const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;

/** Store the API key in a cookie. Never logged or echoed back to the UI. */
export function setApiKeyCookie(key: string): void {
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(key)}; path=/; max-age=${ONE_YEAR_SECONDS}; SameSite=Strict${secure}`;
}

/** Read the stored API key, or null if no cookie is set. */
export function getApiKeyCookie(): string | null {
  const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

/** Delete the stored API key cookie (logout / invalid-key recovery). */
export function clearApiKeyCookie(): void {
  document.cookie = `${COOKIE_NAME}=; path=/; max-age=0; SameSite=Strict`;
}

const CB_TOKEN_COOKIE_NAME = 'raiqon_cb_token';

/** Store the user's Codebeamer JWT (forwarded as Authorization: Bearer on workflow triggers). */
export function setCbTokenCookie(token: string): void {
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${CB_TOKEN_COOKIE_NAME}=${encodeURIComponent(token)}; path=/; max-age=${ONE_YEAR_SECONDS}; SameSite=Strict${secure}`;
}

/** Read the stored Codebeamer JWT, or null if none is set. */
export function getCbTokenCookie(): string | null {
  const match = document.cookie.match(new RegExp(`(?:^|; )${CB_TOKEN_COOKIE_NAME}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

/** Delete the stored Codebeamer JWT. */
export function clearCbTokenCookie(): void {
  document.cookie = `${CB_TOKEN_COOKIE_NAME}=; path=/; max-age=0; SameSite=Strict`;
}
